import { render, staticRenderFns } from "./CombinationSale.vue?vue&type=template&id=f1d07d42&scoped=true"
import script from "./CombinationSale.vue?vue&type=script&lang=js"
export * from "./CombinationSale.vue?vue&type=script&lang=js"
import style0 from "./CombinationSale.vue?vue&type=style&index=0&id=f1d07d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d07d42",
  null
  
)

export default component.exports